import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import LoadingView from '../../Loader/LoadingView';
import { toast } from 'react-toastify';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const AddUserPlan = (props) =>
{
	const { open, userData, handleClose, handleSave, plans, userType } = props;

	// eslint-disable-next-line quotes, no-console
	// console.log("userData ==== ", userData);
	const staticPlan = {
		'customerPlanA' : 'Personal Conference Room for $6/month',
		'customerPlanB' : 'Basic Conference Room for $11/month',
		'customerPlanC' : 'Basic Pro Conference Room for $21/month',
		'customerPlanD' : 'KonX eCard for $41',

		'EnterpriseRoom' : 'Enterprise Conference Room for $81/month',

		'BusinessRoom' : 'Business Conference Room for $26/month',

		'CorporateRoom' : 'Corporate Conference Room for $51/month'

		// 'planA' : '1 KONX PACK FOR $250',

		// 'planB' : '1 KONX PACK FOR $500',

		// 'planC' : '1 KONX PACK FOR $250 AND 1 KONX ECARD PACK FOR $500'
	};
	const [ plan, setPlan ] = useState('');
	const [ isLoading, setLoading ] = useState(false);
	const [ quantity, setQuantity ] = useState(1);
	const handleSubmit = () =>
	{
		if (plan && plan !== '')
		{

			const type = staticPlan[plan] ?'' : 'planD';

			setLoading(true);
			handleSave({ userId: userData._id, fname: userData.fname, plan, type, quantity });
		}
		else
		{
			toast.error('Please select the package');
		}

	};

	const handleChange = (event) =>
	{
		setPlan(event.target.value);
	};

	const handleQuantityChange = (event) =>
	{
		setQuantity(event.target.value);
	};

	return (
		<Dialog open={open}>
			<DialogTitle>Add Package</DialogTitle>
			<DialogContent>
				{isLoading && <LoadingView />}
				<FormControl>
					{/* <FormLabel id='demo-radio-buttons-group-label'>Select Plackage</FormLabel> */}
					<RadioGroup
						aria-labelledby='demo-radio-buttons-group-label'
						defaultValue='female'
						name='radio-buttons-group'
						value={plan}
						onChange={handleChange}
					>
						{Object.keys(plans)
							.slice(0, userType === 'Admin' ? Object.keys(plans).length : Object.keys(plans).length)
							.map((key) => (
								<FormControlLabel
									key={`plan-${key}`}
									value={key}
									control={<Radio />}
									label={plans[key]}
								/>
							))}
					</RadioGroup>
				</FormControl>
				<FormControl fullWidth margin='normal'>
					<FormLabel>Select Quantity</FormLabel>
					<Select value={quantity} onChange={handleQuantityChange}>
						{[ ...Array(60).keys() ].map((num) => (
							<MenuItem key={num + 1} value={num + 1}>
								{num + 1}
							</MenuItem>
						))}
					</Select>
				</FormControl>

			</DialogContent>

			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSubmit}>Save</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddUserPlan;